
import { PostApi } from '@/api/PostApi';
import PostsListCard from '@/components/post/PostsListCard.vue';
import PublishPostCard from '@/components/post/PublishPostCard.vue';
import { ChainViewMixin } from '@/mixins/ChainViewMixin';
import { Post, Chain } from 'ignite360-core';
import { mixins } from 'vue-class-component';
import { Component, Watch } from 'vue-property-decorator';

@Component({
  name: 'chain-content-posts',
  components: { PostsListCard, PublishPostCard },
})
export default class ChainContentPosts extends mixins(ChainViewMixin) {
  loadedPosts: Post[] = [];

  @Watch('chain', { immediate: true })
  async onChainChange(chain: Chain) {
    await this.loadPosts(chain);
  }

  async loadPosts(chain: Chain) {
    this.loadedPosts = await PostApi.loadChainPosts(chain.id);
  }
}
